import CONSTANTS from "@/common/constants";

const commonRoutes = [
  {
    path: "/workspace/:taskId",
    name: CONSTANTS.ROUTE.NAME.WORKSPACE,
    component: () => import("@/views/Workspace/Workspace.vue"),
    meta: {
      auth: CONSTANTS.ROUTE.CODE.WORKSPACE,
      layout: "NO_HEADER",
    },
  },
  {
    path: "/test/:testId",
    name: CONSTANTS.ROUTE.NAME.TESTSPACE,
    component: () => import("@/views/Testspace/Workspace.vue"),
    meta: {
      auth: CONSTANTS.ROUTE.CODE.WORKSPACE,
      layout: "NO_HEADER",
    },
  },
  {
    path: "/task",
    name: CONSTANTS.ROUTE.NAME.TASK,
    component: () => import("@/views/Task/Task.vue"),
    meta: {
      auth: CONSTANTS.ROUTE.CODE.DASHBOARD_MANAGER,
      layout: "FULL",
    },
  },
  {
    path: "/PriceSetting",
    name: CONSTANTS.ROUTE.NAME.PRICESETTING,
    component: () => import("@/views/PriceSetting/PriceSetting.vue"),
    meta: {
      auth: CONSTANTS.ROUTE.CODE.MYPAGE,
      layout: "FULL",
    },
  },
  {
    path: "/develop/components",
    name: "DEVELOP_COMPONENTS",
    component: () => import("@/views/Develop/Components.vue"),
    meta: { auth: false },
  },
  {
    path: "/develop/test",
    name: "DEVELOP_TEST",
    component: () => import("@/views/Develop/Zorder.vue"),
    meta: { auth: false },
  },
  {
    path: "/guide/certification",
    name: CONSTANTS.ROUTE.NAME.CERTIFICATION,
    component: () => import("@/views/Guide/Guide.vue"),
  },
  {
    path: "*",
    name: CONSTANTS.ROUTE.NAME.NOTFOUND,
    component: () => import("@/views/NotFound/NotFound.vue"),
    meta: { auth: false },
  },
  {
    path: "/admin",
    name: CONSTANTS.ROUTE.NAME.ADMIN,
    component: () => import("@/views/Admin/Admin.vue"),
    meta: {
      auth: CONSTANTS.ROUTE.CODE.MYPAGE,
      layout: "FULL",
    },
  },
];

export default commonRoutes;
